import { Component, OnInit } from '@angular/core';
import { BasicProvider } from "../providers/basic/basic";
import { HttpClient, HttpHeaders } from "@angular/common/http";

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.css']
})
export class FaqComponent implements OnInit {

  constructor(
    public bp: BasicProvider,
    public httpClient: HttpClient
    ) { }
  faqList = [];
  selector = '';
  offset = 0;
  limit = 15;
  ngOnInit() {
    this.getFaqList();
  }


  getFaqList(){
    let api = "warehouse/get_faqs";
    this.bp.hitApi(api, 'GET', {limit: this.limit, offset: this.offset}, true, true)
    .subscribe(
      (success) => {
        if( success.type == true ){
          if(this.offset){
            this.faqList.push(...success.data);
          }
          this.faqList = success.data;

        }
      })
  }


  onScroll(infiniteScroll, fromPaginate = true ) {
    console.log("offset on scroll call ")
    this.offset = this.offset+10;
    this.limit = this.limit+10;
    this.getFaqList();
  }


}



// WEBPACK FOOTER //
// ./src/app/faq/faq.component.ts